import {
  financialServiceGuide,
  keyFactSheet,
  privacyPolicyInfo,
  productDisclosureStatement,
  termsAndConditions,
} from 'scenes/common/helpers/contacts';

export const termsAndConditionsLinks = [
  financialServiceGuide,
  keyFactSheet,
  productDisclosureStatement,
  termsAndConditions,
  privacyPolicyInfo,
];
